import script from "./VerificationStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationStatus.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationStatus.vue?vue&type=style&index=0&id=4e8d527e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8d527e"]])

export default __exports__